import { render } from "./refund-dialog.vue?vue&type=template&id=2148f45a&scoped=true"
import script from "./refund-dialog.vue?vue&type=script&lang=js"
export * from "./refund-dialog.vue?vue&type=script&lang=js"

import "./refund-dialog.vue?vue&type=style&index=0&id=2148f45a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2148f45a"]])

export default __exports__